import styled from "styled-components";


const ErrorMessage = styled.p`
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
`;

export default ErrorMessage